import React from 'react';
import { useParams } from 'react-router-dom';
import AddContractor from './AddContractor';

const ViewSubcontractor = () => {
  const { id } = useParams();

  return <AddContractor viewMode={true} vendorId={id} />;
};

export default ViewSubcontractor;

